import { SKILLS_ROUTES } from '../../constants/_routes'
import skillsTypes from '../../constants/skillsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_skill_request = () => {
  return {
    type: skillsTypes.create.request
  }
}

const create_skill_success = (response) => {
  return {
    type: skillsTypes.create.success,
    payload: response.data
  }
}

const create_skill_failure = (messages) => {
  return {
    type: skillsTypes.create.failure,
    payload: messages
  }
}

const create_skill = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_skill_request())

    // Request
    axios.post(
      SKILLS_ROUTES.create,
      values
    ).then( response => {
      // success
      dispatch( create_skill_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating skill."]
      }
      // dispatch( try_force_logoff(error.response) )
      dispatch( create_skill_failure(errors))
    })
  }

}

export {
  create_skill
}



// WEBPACK FOOTER //
// ./src/js/actions/skills/create.js